import React from 'react'
import { Spinner, Button } from '@blueprintjs/core'

import fetch from 'src/utils/fetch'
import { parseJSON } from 'src/utils/http'

export default class CmdbStatus extends React.Component {
    state = {
        loading: true,
        cmdb: null,
        reporting: null,
    }
    componentDidMount() {
        fetch
            .get('/api/cmdb/health/')
            .then(parseJSON)
            .then((response) => {
                this.setState({
                    loading: false,
                    cmdb: response.data.cmdb,
                    reporting: response.data.reporting,
                })
            })
    }
    render() {
        const { loading, cmdb, reporting } = this.state
        return loading ? (
            <div style={{ paddingTop: 20 }}>
                <Spinner />
            </div>
        ) : (
            <div style={{ width: '100%', padding: 10, textAlign: 'center' }}>
                <Button
                    style={{ marginRight: 10 }}
                    intent={cmdb ? 'success' : 'danger'}
                >
                    USD CMDB
                </Button>
                <Button intent={reporting ? 'success' : 'danger'}>
                    Reporting Database
                </Button>
            </div>
        )
    }
}
